import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/metro-runtime';
function resolveWixIamVerificationV1VerificationServiceUrl(opts) {
    const domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/_api/iam/verification',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/iam/verification',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings }));
}
/**
 * starts a verification process
 * example: sends a code to the identity's email
 */
export function start(payload) {
    function __start({ host }) {
        const metadata = {
            entityFqdn: 'wix.iam.verification.v1.start_response',
            method: 'POST',
            methodFqn: 'wix.iam.verification.v1.VerificationService.Start',
            url: resolveWixIamVerificationV1VerificationServiceUrl({
                protoPath: '/v1/Start',
                data: payload,
                host,
            }),
            data: payload,
        };
        return metadata;
    }
    return __start;
}
/**
 * Continues the registration process when a member is required to verify an email address
 * using a verification code received by email.
 *
 * Email verification is required when the registering member is already listed as a contact.
 *
 * Typically, after a successful verification, you generate and use member tokens for the
 * registered member so that subsequent API calls are called as part of a member session.
 */
export function verifyDuringAuthentication(payload) {
    function __verifyDuringAuthentication({ host }) {
        const metadata = {
            entityFqdn: 'wix.iam.verification.v1.start_response',
            method: 'POST',
            methodFqn: 'wix.iam.verification.v1.VerificationService.VerifyDuringAuthentication',
            url: resolveWixIamVerificationV1VerificationServiceUrl({
                protoPath: '/v1/auth/verify',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'identity.createdDate' },
                        { path: 'identity.updatedDate' },
                        { path: 'identity.identityProfile.customFields.value.dateValue' },
                        { path: 'additionalData.dateValue' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'identity.identityProfile.customFields.value.numValue' },
                        { path: 'additionalData.numValue' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __verifyDuringAuthentication;
}
/**
 * Resend the verification email and continue the registration process when a member is required to verify an email address
 * using a verification code received by email.
 */
export function resendDuringAuthentication(payload) {
    function __resendDuringAuthentication({ host }) {
        const metadata = {
            entityFqdn: 'wix.iam.verification.v1.start_response',
            method: 'POST',
            methodFqn: 'wix.iam.verification.v1.VerificationService.ResendDuringAuthentication',
            url: resolveWixIamVerificationV1VerificationServiceUrl({
                protoPath: '/v1/auth/resend',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'identity.createdDate' },
                        { path: 'identity.updatedDate' },
                        { path: 'identity.identityProfile.customFields.value.dateValue' },
                        { path: 'additionalData.dateValue' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'identity.identityProfile.customFields.value.numValue' },
                        { path: 'additionalData.numValue' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __resendDuringAuthentication;
}
//# sourceMappingURL=iam-verification-v1-start-response-verification.http.js.map